export default __webpack_public_path__ + "static/7_9-00c46e834f33ade6f222d249d427d475.png";